export const SESSION_TRAFFIC_SOURCE_KEY = "traffic-source";
export const SESSION_WALLET_DETECTED_KEY = "wallet-detected";
export const SESSION_CURRENT_URL_KEY = "analytics-current-url";
export const SESSION_USER_ID_KEY = "user-id";

export const LOCAL_ANONYMOUS_ID_KEY = "anonymous-id";
